import { render, staticRenderFns } from "./IconChevronSm.vue?vue&type=template&id=112de4a4&scoped=true&"
import script from "./IconChevronSm.vue?vue&type=script&lang=js&"
export * from "./IconChevronSm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112de4a4",
  null
  
)

export default component.exports